var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProveeCriotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 75,
    viewBox: "0 0 260 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_215)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.202 47.3509H136.844V25.4356H145.546V19.6743H132.024C129.371 19.6743 127.202 21.8434 127.202 24.4962V47.3509Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.246 19.418H158.14V47.5951H148.246V19.418Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.246 16.0347H158.14V10.1484H148.246V16.0347Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.524 47.5978H181.993C184.576 47.5978 186.69 45.4856 186.69 42.9025V23.9289C186.69 21.3456 184.576 19.2322 181.993 19.2322H165.524C162.941 19.2322 160.828 21.3456 160.828 23.9289V42.9025C160.828 45.4856 162.941 47.5978 165.524 47.5978ZM170.848 41.1477H176.669V25.6824H170.848V41.1477Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.189 19.4225H191.32L195.39 10.4048H200.336V19.4225H206.097V25.6843H200.336V41.1819H206.348V47.4436H195.828C193.348 47.4436 191.32 45.4152 191.32 42.9354V25.6843H188.189V19.4225Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.733 19.6743H231.017C232.878 19.6743 234.398 21.1956 234.398 23.055V36.3306H217.492V41.8401H234.398V47.6012H212.984C210.917 47.6012 209.226 45.911 209.226 43.844V23.1814C209.226 21.2525 210.804 19.6743 212.733 19.6743Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.265 25.6829H217.184V30.5666H227.265V25.6829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.911 18.8223H258.629V25.3343H246.577V41.3648H258.629V47.8768H241.291C239.048 47.8768 237.214 46.0433 237.214 43.8021V23.5034C237.214 20.928 239.322 18.8223 241.896 18.8223H241.911Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5568 45.9101L81.0574 66.9481C36.1943 79.4264 9.77319 65.3185 2.44696 45.394C-2.96319 29.0551 4.14755 16.2452 22.449 6.58618C11.3047 18.9497 7.36294 31.0423 22.9495 42.4031C40.669 51.6455 59.831 53.0313 80.5568 45.9101Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4315 2.07642C81.7682 4.70601 74.3375 17.6049 69.0357 18.6063C48.7718 17.4011 34.393 16.4876 19.4437 24.6176C21.6178 13.6232 28.4861 4.84149 48.3718 2.20158L80.4315 2.07642Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.575 41.8387H111.676V15.7891H121.318C123.109 15.7891 124.575 14.3247 124.575 12.5338V9.2771H101.757C101.013 9.2771 100.405 9.88611 100.405 10.6293V46.9984C100.405 47.7417 101.013 48.3507 101.757 48.3507H124.575V41.8387Z",
    fill: "#D0D2D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.117,
    height: 73.7991,
    fill: "white",
    transform: "translate(0.680054 0.353271)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProveeCriotec);
export default __webpack_public_path__ + "static/media/provee-criotec.4ff40f2c7d570143841f8eca3ab3363d.svg";
export { ForwardRef as ReactComponent };